import { observer } from "mobx-react-lite";
import { Tierlist } from "./presenter/tierlistPresenter";
import { Login } from "./presenter/loginPresenter";
import { CsvInput } from "./presenter/csvInputPresenter";
import "/src/style/generalStyle.css";

import { createHashRouter, RouterProvider, useParams } from "react-router-dom";

function makeRouter(props) {
    return createHashRouter([
        {
            path: "/tierlist",
            element: <Tierlist movieModel={props.movieModel}/>
        },
        {
            path: "/",
            element: <Login loginModel={props.loginModel}/>
        },
        {
            path: "/input",
            element: <CsvInput movieModel={props.movieModel}/>
        }
    ])
}

const ReactRoot = observer (
    function ReactRoot(props) {
        return (
            <div className="mainContent">
                <RouterProvider router={makeRouter(props)}/>
            </div>
        );
    }
);

export { ReactRoot };